module.exports = __webpack_public_path__ + "img/activity2.e684f405.png";